import { WhichWeightAPI } from 'WhichWeightAPI'
import { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { resetUserState } from 'redux/slices/user'
import kinesisLogo from "media/kinesis_logo.png"

import ScreenFrame from 'components/Frame/ScreenFrame'
import ContentFrame from 'components/Frame/ContentFrame'
import SolidButton from 'components/Buttons/SolidButton'
import BrandColorButton from 'components/Buttons/BrandColorButton'

export default function JoinOrganizationView() {

    const navigate = useNavigate()
    const dispatch = useDispatch()

    const userId = useSelector(state => state.user.id)

    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')
    const [organizationCode, setOrganizationCode] = useState('')
    const [errorMessage, setErrorMessage] = useState('')
    const [joinLoading, setJoinLoading] = useState(false);

    const HandleFormChange = (key, value) => {
        switch (key) {
            case 'firstName':
                var alphabetOnly = value.replace(/[^a-zA-Z]/g, '');
                setFirstName(alphabetOnly)
                break

            case 'lastName':
                var alphabetOnly = value.replace(/[^a-zA-Z]/g, '');
                setLastName(alphabetOnly)
                break

            case 'organizationCode':
                setOrganizationCode(value)
                break

            default:
                console.error(key + ' is not a valid form key')
                break
        }
    }

    const ValidateInputs = () => {
        if (firstName.length === 0) { 
            setErrorMessage('First name is required!'); 
            return false;
        }

        if (lastName.length === 0) { 
            setErrorMessage('Last name is required!'); 
            return false;
        }

        if (organizationCode.length === 0) { 
            setErrorMessage('Organization code is required!'); 
            return false;
        }

        return true
    }

    const OnJoinOrganization = async () => {

        var inputsValid = ValidateInputs()

        if (inputsValid === false) return

        try {
            setJoinLoading(true)

            const jsonBody = {
                userId: userId,
                firstName: firstName,
                lastName: lastName,
                organizationCode: organizationCode
            }

            // console.log(jsonBody)

            const join_organization_result = await WhichWeightAPI("BILLING", "POST", "/coach_join_organization", jsonBody);

            // console.log(join_organization_result);

            if (join_organization_result.data.status === "failure") {
                console.error(join_organization_result);
                setJoinLoading(false)
                setErrorMessage('Failed to join organization. Please try again. Reach out to support@kinesisintegrated.com for more assistance.');
                return;
            }

            setJoinLoading(false)

            dispatch(resetUserState())

            navigate('/home')
        }
        catch (error) {
            console.error(error)
            setErrorMessage('Failed to join organization. Please try again. Reach out to support@kinesisintegrated.com for more assistance.');
        }
    }

    return (
        <ScreenFrame>
            <div className="flex flex-col h-full w-2/3 mx-auto gap-y-4">

                {/* Header */}
                <div className="text-center space-y-2">
                    <div className="flex justify-center mb-2">
                        <img
                            src={kinesisLogo}
                            alt="Kinesis Logo"
                            className="w-32 h-auto"
                        />
                    </div>

                    <h2 className="text-2xl text-gray-900">
                        Join a Kinesis Organization
                    </h2>

                    <p className="text-base text-gray-600 max-w-xl mx-auto">
                        Enter the orgizaiton code provided by the organization owner below
                    </p>
                </div>

                <ContentFrame>
                    <div className="w-full p-6 gap-6 grid grid-cols-2">

                        {/* First Name */}
                        <div>
                            <label htmlFor="first-name" className="block text-sm font-medium leading-6 text-gray-900">
                                First name*
                            </label>
                            <div className="mt-2">
                                <input
                                    id="first-name"
                                    name="first-name"
                                    type="text"
                                    placeholder="Enter first name here"
                                    autoComplete="given-name"
                                    className="block w-full rounded-lg border-0 px-3 py-2.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6 focus:outline-orange-400"
                                    value={firstName}
                                    onChange={(event) => HandleFormChange('firstName', event.target.value)}
                                    maxLength={255}
                                />
                            </div>
                        </div>

                        {/* Last Name */}
                        <div>
                            <label htmlFor="last-name" className="block text-sm font-medium leading-6 text-gray-900">
                                Last name*
                            </label>
                            <div className="mt-2">
                                <input
                                    id="last-name"
                                    name="last-name"
                                    type="text"
                                    placeholder="Enter last name here"
                                    autoComplete="family-name"
                                    className="block w-full rounded-lg border-0 px-3 py-2.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6 focus:outline-orange-400"
                                    value={lastName}
                                    onChange={(event) => HandleFormChange('lastName', event.target.value)}
                                    maxLength={255}
                                />
                            </div>
                        </div>

                        {/* Organization Code */}
                        <div className="col-span-2">
                            <label htmlFor="organizationCode" className="block text-sm font-medium leading-6 text-gray-900">
                                Organization Code*
                            </label>
                            
                            <div className="my-2">
                                <input
                                    id="organizationCode"
                                    name="organizationCode"
                                    type="text"
                                    placeholder="Enter organization code here"
                                    className="block w-full rounded-lg border-0 px-3 py-2.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6 focus:outline-orange-400"
                                    value={organizationCode}
                                    onChange={(event) => HandleFormChange('organizationCode', event.target.value)}
                                    maxLength={255}
                                />
                            </div>

                            <div className='text-xs text-gray-600 italic'>Please reach out to your organization admin if you do not know the organization code</div>
                        </div>
                    </div>
                </ContentFrame>

                <div className='text-center text-xs text-gray-500'>
                    By clicking "Join Organization" you agree to the Kinesis Integrated
                    {' '}<a href='https://www.kinesisintegrated.com/privacy' className='text-xs text-orange-500 cursor-pointer hover:underline' target="_blank" rel="noopener noreferrer">Privacy Policy</a>
                    {' and '}<a href='https://www.kinesisintegrated.com/terms' className='text-xs text-orange-500 cursor-pointer hover:underline' target="_blank" rel="noopener noreferrer">Terms of Use</a>
                </div>

                {errorMessage !== '' && <div className='text-center text-xs text-red-500'>{errorMessage}</div>}

                <div className="flex items-center justify-end gap-x-4">
                    <div className='w-32'>
                        <SolidButton
                            text='Cancel'
                            action={() => navigate('/')}
                            className='shadow-md'
                        />
                    </div>

                    <div className='w-64'>
                        <BrandColorButton
                            text='Join Organization'
                            action={() => OnJoinOrganization()}
                            isLoading={joinLoading}
                            className='shadow-md'
                        />
                    </div>
                </div>
            </div>
        </ScreenFrame>
    )

}